import { useTranslation } from 'react-i18next';
import { ReactComponent as BanknoteIcon } from '../../../assets/delivery-tag-icons/banknote.svg';
import { ReactComponent as CreditCardIcon } from '../../../assets/delivery-tag-icons/credit-card.svg';
import { ReactComponent as PrinterIcon } from '../../../assets/delivery-tag-icons/printer.svg';
import { ReactComponent as PrinterCrossedIcon } from '../../../assets/delivery-tag-icons/printer-crossed.svg';

import { exhaustiveGuard } from '../../../utils/generic/generic.utils';
import {
  DeliveryInfoTagColor,
  DeliveryInfoTagContainer,
} from './delivery-option-card.styles';
import { DeliveryInfoTagType } from '../../../models/delivery-options/common';

interface Props {
  type: DeliveryInfoTagType;
}

function getTagConfig(type: DeliveryInfoTagType):
  | {
      icon: JSX.Element;
      translationKey: string;
      textColor: DeliveryInfoTagColor;
    }
  | undefined {
  switch (type) {
    case 'pay-online':
      return {
        icon: <CreditCardIcon />,
        translationKey: 'delivery_options_tag_pay_online',
        textColor: 'grey',
      };
    case 'pay-drop-off':
      return {
        icon: <BanknoteIcon />,
        translationKey: 'delivery_options_tag_pay_dropoff',
        textColor: 'grey',
      };
    case 'no-label':
      return {
        icon: <PrinterCrossedIcon />,
        translationKey: 'delivery_options_tag_no_label',
        textColor: 'green',
      };
    case 'label':
      return {
        icon: <PrinterIcon />,
        translationKey: 'delivery_options_tag_print_label',
        textColor: 'red',
      };
    default:
      exhaustiveGuard(type);
  }
}

const DeliveryInfoLabel = ({ type }: Props) => {
  const { t } = useTranslation();

  const config = getTagConfig(type);
  if (!config) return;

  const { icon, translationKey, textColor } = config;

  return (
    <DeliveryInfoTagContainer $textColor={textColor}>
      {icon}
      {t(translationKey)}
    </DeliveryInfoTagContainer>
  );
};

export default DeliveryInfoLabel;
